"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALERTS_NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ALERTS_NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "ATTENDEE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ATTENDEE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "ATTENDEE_NETWORKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ATTENDEE_NETWORKING;
  }
});
Object.defineProperty(exports, "ATTENDEE_REPORTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ATTENDEE_REPORTS;
  }
});
Object.defineProperty(exports, "BADGE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BADGE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CONFERENCES_CONVENTIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONFERENCES_CONVENTIONS;
  }
});
Object.defineProperty(exports, "CRM_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CRM_INTEGRATION;
  }
});
Object.defineProperty(exports, "CUSTOMIZABLE_BRANDING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZABLE_BRANDING;
  }
});
Object.defineProperty(exports, "EVENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EVENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "EVENT_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EVENT_MARKETING;
  }
});
Object.defineProperty(exports, "EVENT_WEBSITE_CREATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EVENT_WEBSITE_CREATION;
  }
});
Object.defineProperty(exports, "EXHIBIT_VENDOR_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EXHIBIT_VENDOR_MANAGEMENT;
  }
});
Object.defineProperty(exports, "FILE_SHARING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FILE_SHARING;
  }
});
Object.defineProperty(exports, "GAMIFICATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.GAMIFICATION;
  }
});
Object.defineProperty(exports, "LEAD_GENERATION_RETRIEVAL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LEAD_GENERATION_RETRIEVAL;
  }
});
Object.defineProperty(exports, "LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LIVE_CHAT;
  }
});
Object.defineProperty(exports, "MOBILE_CHECK_IN", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE_CHECK_IN;
  }
});
Object.defineProperty(exports, "MULTI_HOSTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTI_HOSTS;
  }
});
Object.defineProperty(exports, "ONSITE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ONSITE_MANAGEMENT;
  }
});
Object.defineProperty(exports, "POLLS_VOTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.POLLS_VOTING;
  }
});
Object.defineProperty(exports, "Q_A", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.Q_A;
  }
});
Object.defineProperty(exports, "REGISTRATION_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REGISTRATION_MANAGEMENT;
  }
});
Object.defineProperty(exports, "REPORTING_EVENT_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REPORTING_EVENT_ANALYTICS;
  }
});
Object.defineProperty(exports, "ROLE_BASED_ACCESS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ROLE_BASED_ACCESS;
  }
});
Object.defineProperty(exports, "SESSION_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SESSION_MANAGEMENT;
  }
});
Object.defineProperty(exports, "SITE_SELECTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SITE_SELECTION;
  }
});
Object.defineProperty(exports, "SOCIAL_MEDIA_INTEGRATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_MEDIA_INTEGRATIONS;
  }
});
Object.defineProperty(exports, "SOCIAL_MEDIA_PROMOTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_MEDIA_PROMOTION;
  }
});
Object.defineProperty(exports, "SOFTWARE_INTEGRATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOFTWARE_INTEGRATIONS;
  }
});
Object.defineProperty(exports, "SUPPLIER_PROCUREMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SUPPLIER_PROCUREMENT;
  }
});
Object.defineProperty(exports, "TICKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TICKETING;
  }
});
Object.defineProperty(exports, "VENUE_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VENUE_MANAGEMENT;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Event.js
// module id = 570
// module chunks = 209 210 211 212 213